var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9792 6.13524C11.9792 7.176 11.5771 8.49531 10.9104 9.83636C10.2501 11.1643 9.37023 12.4337 8.50353 13.3625C8.22126 13.665 7.77717 13.665 7.4949 13.3625C6.62821 12.4337 5.74829 11.1643 5.08806 9.83636C4.42132 8.49531 4.01922 7.176 4.01922 6.13524C4.01922 4.88295 4.46989 3.98023 5.14782 3.3817C5.839 2.77147 6.83343 2.4201 7.99922 2.4201C9.165 2.4201 10.1594 2.77147 10.8506 3.3817C11.5286 3.98023 11.9792 4.88295 11.9792 6.13524Z",
    stroke: "#233544",
    strokeWidth: 1.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31385 6.39994C9.31385 7.12527 8.72585 7.71327 8.00052 7.71327C7.27519 7.71327 6.68719 7.12527 6.68719 6.39994C6.68719 5.6746 7.27519 5.0866 8.00052 5.0866C8.72585 5.0866 9.31385 5.6746 9.31385 6.39994Z",
    stroke: "#233544",
    strokeWidth: 1.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.589c90acd7368aeb0007d961a38df941.svg";
export { ForwardRef as ReactComponent };